export const ARTIFACT_TYPES = [
  "markdown",
  "html",
  "react",
  "svg",
  "mermaid",
  "chart",
  "sheet",
  "slides",
] as const

export type ArtifactType = (typeof ARTIFACT_TYPES)[number]

/**
 * Narrows an arbitrary string (e.g. a persisted `artifactType` from the API)
 * to a known ArtifactType. Unknown values must be coerced by the caller —
 * reading `artifactRegistry[unknownType]` would otherwise be `undefined`.
 */
export function isArtifactType(value: string | undefined): value is ArtifactType {
  return value !== undefined && (ARTIFACT_TYPES as readonly string[]).includes(value)
}

export type ArtifactCommand = "create" | "update" | "rewrite"

export type ParsedArtifactBlock = {
  identifier: string
  type: ArtifactType
  title: string
  command: ArtifactCommand
  rawContent: string
  complete: boolean
}

export type ExtractResult = {
  displayText: string
  blocks: ParsedArtifactBlock[]
}

export type UpdatePair = { oldStr: string; newStr: string }

export type ApplyUpdatesResult =
  | { ok: true; content: string }
  | { ok: false; error: "no_match" | "multiple_matches"; failedIndex: number }
